export const RATING_WORKFLOW_STATES = {
  NEW: 'new',
  POSTED: 'posted',
  DELETED: 'deleted' // this state is present only on client
};
